import { isWithBackground } from './utils';
export const buildBackgroundDeclarations = ({ theme, stylingType, selected, hovered, alignment, disabled, active, }) => {
    if (hovered) {
        if (alignment === 'horizontal' || disabled) {
            return '';
        }
        return `background-color: rgba(${theme.colors.transparentBlack}, 0.08);`;
    }
    if (active) {
        if (disabled || alignment === 'horizontal') {
            return '';
        }
        if (stylingType === 'withAdditionalElement') {
            return `background-color: rgba(${theme.colors.transparentBlack}, 0.12);`;
        }
        if (isWithBackground(stylingType)) {
            return `background-color: rgba(${theme.colors.transparentBlack}, 0.12);`;
        }
        return `background-color: ${theme.colors.grey15};
  `;
    }
    if ((isWithBackground(stylingType) || stylingType === 'withIcons') && selected) {
        return `background-color: rgba(${theme.colors.transparentBlack}, 0.12);`;
    }
    if (isWithBackground(stylingType)) {
        return `background-color: rgba(${theme.colors.transparentBlack}, 0.04);`;
    }
    return '';
};
export const buildBorderDeclarations = ({ theme, disabled, focused, focus, active, stylingType, alignment, }) => {
    const borderDeclarations = [];
    borderDeclarations.push(`border: 1px solid rgba(${theme.colors.transparentWhite}, 0);`);
    if (active) {
        if (isWithBackground(stylingType)) {
            borderDeclarations.push(`border: 1px solid ${theme.colors.grey05};`);
        }
        else if (alignment === 'vertical' && !disabled) {
            borderDeclarations.push(`border: 1px solid ${theme.colors.grey15};`);
        }
    }
    if (focus) {
        borderDeclarations.push(`outline: none;`);
        if (focused) {
            if (!disabled) {
                borderDeclarations.push(`border: 1px solid ${theme.colors.primaryLight};`);
                borderDeclarations.push(`outline: 1px solid ${theme.colors.primaryLight};`);
            }
        }
    }
    return borderDeclarations.join(' ');
};
export const buildAfterDeclarations = ({ selected, theme, alignment, disabled, hovered, active, stylingType, isActive, changeOnMouseOver, }) => {
    const borderDeclarations = [];
    if (active && !disabled) {
        if (alignment === 'horizontal') {
            borderDeclarations.push('bottom: 0;');
            borderDeclarations.push('height: 0.25rem;');
            borderDeclarations.push(`background-color: ${theme.colors.grey15};`);
        }
        else {
            borderDeclarations.push(`background-color: ${theme.colors.white};`);
        }
    }
    else if ((selected && !changeOnMouseOver) || isActive) {
        if (alignment === 'horizontal') {
            borderDeclarations.push('bottom: 0;');
            borderDeclarations.push('height: 0.25rem;');
            borderDeclarations.push(`background-color: ${theme.colors.primaryLight};`);
        }
        else if (!stylingType) {
            borderDeclarations.push('bottom: -1px;');
            borderDeclarations.push('height: 1px;');
            borderDeclarations.push(`background-color: ${theme.colors.primaryLight};`);
        }
    }
    else if (hovered && !disabled && alignment === 'horizontal') {
        borderDeclarations.push('bottom: 0;');
        borderDeclarations.push('height: 0.25rem;');
        borderDeclarations.push(`background-color: ${theme.colors.grey10};`);
    }
    return borderDeclarations.join(' ');
};
export const buildBeforeDeclarations = ({ stylingType, selected, theme, disabled, hovered, active, }) => {
    const borderDeclarations = [];
    if (isWithBackground(stylingType)) {
        if (active && !disabled) {
            borderDeclarations.push(`background-color: ${theme.colors.grey15};`);
        }
        else if (selected) {
            borderDeclarations.push(`background-color: ${theme.colors.primaryLight};`);
        }
        else if (hovered && !disabled) {
            borderDeclarations.push(`background-color: rgba(${theme.colors.transparentBlack}, 0.4);`);
        }
        else {
            borderDeclarations.push(`background-color: rgba(${theme.colors.transparentBlack}, 0.08);`);
        }
    }
    return borderDeclarations.join(' ');
};
export const buildPaddingDeclarations = ({ alignment, stylingType }) => {
    const borderDeclarations = [];
    if (isWithBackground(stylingType)) {
        borderDeclarations.push(`padding: 0 0.5rem 0 0.75rem; margin: 0.125rem 0 0.125rem 0.5rem;`);
    }
    else
        borderDeclarations.push('padding: 0rem;');
    if (alignment === 'horizontal')
        borderDeclarations.push('padding-bottom: 0.5rem;');
    // simple tabs
    if (alignment === 'vertical') {
        if (stylingType) {
            // Tab simple select
            if (stylingType === 'withIcon' || stylingType === 'withIcons')
                borderDeclarations.push('padding-right: 0.5rem;');
        }
        // Tab simple drill down
        else
            borderDeclarations.push('padding-left: 0.5rem;');
    }
    else {
        borderDeclarations.push('padding-right: 0.0rem;');
    }
    return borderDeclarations.join(' ');
};
